export default "__VITE_ASSET__BrGgIdYS__"